<script>
import { Line } from 'vue-chartjs/legacy';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
} from 'chart.js';
ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale
);
export default {
    name: 'LineChart',
    extends: Line,
    components: { Line },
    props: {
        chartData: {
            type: Object,
            required: true,
            default: [],
        },
        chartOptions: {
            type: Object,
            default: null,
        },
    },
};
</script>
